export const DELETE_DMX_PROFILE = 'DELETE_DMX_PROFILE';
export const DELETE_DMX_PROFILE_SUCCESSFUL = 'DELETE_DMX_PROFILE_SUCCESSFUL';
export const DELETE_DMX_PROFILE_FAILED = 'DELETE_DMX_PROFILE_FAILED';
